import React, { useState, useEffect, useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
// import { AppContext } from "AppContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import LoaderAnimation from "pages/LoaderAnimation";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountingBalance from "components/AccountingBalance";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";
import AximTooltip from "components/AximTooltip";

function Accounting(props) {
  const { modalIsOpen,setModalIsOpen, companyId, setCompany,userInfo } = useContext(PrivateRoutesContext);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchedData, setFetchedData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [disbursementData, setDisbursementData] = useState([]);
  const [dataEmpty, setDataEmpty] = useState(false);
  const [checkingData, setCheckingData] = useState(false);

  const [amtAccountingBalance, setAmtAccountingBalance] = useState(null);
  const [amrsAccountingBalance, setAmrsAccountingBalance] = useState(null);
  const [fsgAccountingBalance, setFsgAccountingBalance] = useState(null);
  const [agsgAccountingBalance, setAgsgAccountingBalance] = useState(null);

  // Remittance
  const [remittances, setRemittances] = useState([]);
  const [selectedRemittance, setSelectedRemittance] = useState(null);
  const [isRemittanceVisible, setIsRemittanceVisible] = useState(false);

  // CREDIT TYPES
  const [creditResponse, setCreditResponse] = useState([]);
  const [open, setOpen] = useState(false);

  // SET COLUMN TYPE
  const [columnType, setColumnType] = useState("");
  const [keyType, setKeyType] = useState(null);
  const [doShowError, setDoShowError] = useState(false);
  const [errorText, setErrorText] = useState("");

  console.log(`account ${companyId}`)
  useEffect(() => {
    if(companyId !=null){
      handleChangeCompany()
    }
  }, [companyId]);

  useEffect(() => {
    let selectedCompany = localStorage.getItem(`selectedParentCompanyId`);
    console.log(`current company ${selectedCompany}`)
    if (selectedCompany == null || selectedCompany === "") {
      setModalIsOpen(true)
    }
    else{
      setCompany(selectedCompany,"AP3")
    }

    document.title = "AXIM FringeSecure | AP3 Partner";
  }, []);

  const canDownload = useMemo(() => {
    return !Utils.isBroker(userInfo);
  },[userInfo]);

  const handleClickOpen = (invoiceDetailRowSelected, col) => {
    setColumnType(col);
    setOpen(true);

    if (col === "paymentCol") {
      setCheckingData(true);
      apiGet(apiUrls.getInvoicePaymentAmountDetails(invoiceDetailRowSelected)).then(
        (response) => {
          setPaymentData(response.data);
          setDataEmpty(response.data.length === 0);
        })
        .finally(() => {
          setCheckingData(false);
        });
    } else if (col === "disbursementCol") {
      setCheckingData(true);
      apiGet(apiUrls.getInvoiceDisbursementDetails(invoiceDetailRowSelected)).then(
        (response) => {
          setDisbursementData(response.data);
          setDataEmpty(response.data.length === 0);
        })
        .finally(() => {
          setCheckingData(false);
        });
    } else if (col === "creditCol") {
      setCheckingData(true);
      apiGet(apiUrls.getInvoiceCreditDetails(invoiceDetailRowSelected)).then(
        (response) => {
          let newArray = [];
          Object.keys(response.data).map((item) => {
            if (response.data[item].length > 0) {
              if (item === "creditNotes") {
                newArray.push(
                  `Credit Note: ${response.data[item][0].creditNoteNumber}`
                );
              } else {
                newArray.push(item);
              }
            }
          });
          setKeyType(newArray);

          const creditResponse = [
            ...response.data.overpayments,
            ...response.data.prepayments,
            ...response.data.creditNotes,
          ];

          setCreditResponse(creditResponse);
          setDataEmpty(creditResponse.length === 0);
        }
      )
      .finally(() => {
        setCheckingData(false);
      });
    }
  };

  const downloadInvoice = (invoiceNumber, invoiceId) => {
    let selectedCompany = localStorage.getItem(`selectedParentCompanyId`);
    console.log(invoiceId,'invoiceId');
    apiGet(apiUrls.downloadInvoice(invoiceId), { responseType: "blob" }).then(response => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoiceNumber}.pdf`);
      document.body.appendChild(link);
      link.click();

      console.log("Invoice downloading successfully");
    }).catch(
      (response) => {
        setErrorText("An Error occurred downloading the file.");
        setDoShowError(true);
      }
    );
  }

  const getInvoiceUrl = (invoiceNumber, invoiceId) => {
    apiGet(apiUrls.getInvoiceUrl(invoiceId)).then(response => {
      const url = response.data.invoiceUrl
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    }).catch(
      (response) => {
        setErrorText("An Error occurred getting invoice.");
        setDoShowError(true);
      }
    );
  }

  const downloadCreditNote = (creditNoteNumber, creditNoteId) => {
    let selectedCompany = localStorage.getItem(`selectedCompanyId`);
    console.log(creditNoteId,'creditNoteId');
    apiGet(apiUrls.downloadCreditNote(creditNoteId), { responseType: "blob" }).then(response => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${creditNoteNumber}.pdf`);
      document.body.appendChild(link);
      link.click();

      console.log("Invoice downloading successfully");
    }).catch(
      (response) => {
        setErrorText("An Error occurred downloading the file.");
        setDoShowError(true);
      }
    );
  }

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      Header: "Row ID",
      accessor: "invoiceId",
      disableFilters: true,
    }, 
    {
      Header: "Invoice Id",
      accessor: "invoiceNumber",
      Cell: e => {
        <><Button onClick={() => downloadInvoice(`${e.row.values.invoiceNumber}`,`${e.row.values.invoiceId}`)} color="primary">{e.row.values.invoiceNumber}</Button>
        {
        (e.row.values.invoiceNumber?.endsWith("FSG") && e.row.original.amountDue)>0?<Button onClick={() => getInvoiceUrl(`${e.row.values.invoiceNumber}`,`${e.row.values.invoiceId}`)} color="primary">
        <PaymentIcon/>
        </Button>:<></>}
        </>
      },
    },
    {
      Header: "Reference",
      accessor: "reference",
    },
    {
      Header: "Due Date",
      accessor: (cell) => Utils.formatDate(cell.dueDate),
      Cell: ({row}) => (
        <Box className="text-end">
          {Utils.formatDate(row.original.dueDate)}
        </Box>
      ),
      sortType: "dateSort",
      className: 'text-end',
    },
    {
      Header: "Invoice Total",
      accessor: (cell) => Utils.formatCurrency(cell.total),
      Cell: ({ row }) => (
        <Box className="text-end">
          {Utils.formatCurrency(row.original.total)}
        </Box>
      ),
      className: 'text-end'
    },
    {
      Header: "Amount Due",
      accessor: (cell) => Utils.formatCurrency(cell.amountDue),
      Cell: ({ row }) => (
        <Box className="text-end">
          {Utils.formatCurrency(row.original.amountDue)}
        </Box>
      ),
      className: 'text-end'
    },
    {
      Header: "Payment Applied",
      accessor: (cell) => Utils.formatCurrency(cell.amountPaid),
      Cell: ({ row }) => (
        <>
          <AximTooltip title="View Payments">
            <Button className="float-end" color="primary" aria-label="view payments" component="span"
                onClick={() => {
                  handleClickOpen(row.original.invoiceId, "paymentCol");
                }}
            >
              {Utils.formatCurrency(row.original.amountPaid)}
            </Button>
          </AximTooltip>
        </>
      ),
      className: 'text-end'
    },
    {
      Header: "Credit Applied",
      accessor: (cell) => Utils.formatCurrency(cell.credit),
      Cell: ({ row }) => (
        <>
          <AximTooltip title="View Credits">
            <Button className="float-end" color="primary" aria-label="view payments" component="span"
                onClick={() => {
                  handleClickOpen(row.original.invoiceId, "creditCol");
                }}
            >
              {Utils.formatCurrency(row.original.credit)}
            </Button>
          </AximTooltip>
        </>
      ),
      className: 'text-end'
    },
    {
      Header: "Payment Rcvd",
      accessor: (cell) => Utils.formatDate(cell.paymentDate),
      Cell: ({row}) => (
        <Box className="text-end">
          {Utils.formatDate(row.original.paymentDate)}
        </Box>
      ),
      sortType: "dateSort",
      className: 'text-end'
    },
    {
      Header: "Disbursement Amt",
      accessor: (cell) => Utils.formatCurrency(cell.disbursementAmount),
      Cell: ({ row }) => (
        <>
          <AximTooltip title="View Disbursements">
            <Button className="float-end" color="primary" aria-label="view payments" component="span"
                onClick={() => {
                  handleClickOpen(row.original.invoiceId, "disbursementCol");
                }}
            >
              {Utils.formatCurrency(row.original.disbursementAmount)}
            </Button>
          </AximTooltip>
        </>
      ),
      className: 'text-end'
    },
    {
      Header: "Disbursement Date",
      accessor: (cell) => Utils.formatDate(cell.disbursementDate),
      Cell: ({row}) => (
        <Box className="text-end">
          {Utils.formatDate(row.original.disbursementDate)}
        </Box>
      ),
      sortType: "dateSort",
      className: 'text-end'
    },
  ];

  // PAYMENT AMOUNT HEADERS
  const paymentColumns = [
    {
      Header: "Date",
      accessor: (cell) => Utils.formatDate(cell.date),
    },
    {
      Header: "Amount",
      accessor: (cell) => Utils.formatCurrency(cell.amount),
    },
    {
      Header: "Type",
      accessor: () => "Payment",
    },
  ];

  // CREDIT AMOUNT HEADERS
  const creditColumns = [
    {
      Header: "Date",
      accessor: (cell) => Utils.formatDate(cell.date),
    },
    {
      Header: "Amount",
      accessor: (cell) => Utils.formatCurrency(cell.appliedAmount),
    },
    {
      Header: "Type",
      accessor: () => keyType.join(),
      Cell: ({row}) => (
        <Box className="text-end">
          { keyType.map(k => {
            return <Button onClick={() => downloadCreditNote(`${k.creditNoteNumber}`,`${k.creditNoteID}`)} color="primary">{k.creditNoteNumber}</Button>
          }) }
        </Box>
      ),
    },
  ];

  // DISBERSEMENT AMOUNT HEADERS
  const disbursementColumns = [
    {
      Header: "Date",
      accessor: (cell) => Utils.formatDate(cell.disbursementDate),
    },
    {
      Header: "Amount",
      accessor: (cell) => Utils.formatCurrency(cell.disbursementAmount),
    },
    {
      Header: "Method",
      accessor: "disbursementMethod",
    },
    {
      Header: "Notes",
      accessor: "disbursementNote",
    },
  ];

  

  const handleChangeCompany = () => {
    setIsLoading(true);

    apiGet(apiUrls.getAccounting(companyId)).then(
      (response) => {
        if (response.data.invoices) {
          setFetchedData(response.data.invoices);
        }
        console.log(response.data)
        setAmtAccountingBalance(response.data.amtAccountingBalance)
        setAmrsAccountingBalance(response.data.amrsAccountingBalance)
        setFsgAccountingBalance(response.data.fsgAccountingBalance)
        setAgsgAccountingBalance(response.data.agsgAccountingBalance)
        setRemittances(response.data.remittances);
      }
    )
    .finally(() => {
      setIsLoading(false);
    });
    
    // apiGet(apiUrls.getRemittance(companyId)).then(
    //   (response) => {
    //     setRemittances(response.data);
    //   }
    // )
  }

  const handleRemittance = (remittanceType) => {
    let search = remittances.find(r => r.remittanceType === remittanceType);

    if (search) {
      setSelectedRemittance(search);
      setIsRemittanceVisible(true);
    }
  }

  const handleCloseRemittance = () => {
    setIsRemittanceVisible(false);
  }

  return (
    <>
      <div>
        <div className={`${ButtonStyle.buttonWrapper} ${ButtonStyle.uploadFileWrapper}`}>
          {remittances.map((remittance, index) => 
            <Button
              key={index}
              variant="outlined"
              onClick={() => handleRemittance(remittance.remittanceType)}
              className={ButtonStyle.CsubmitBtn}
              style={{ marginRight: "15px" }}
              startIcon={<VisibilityOutlinedIcon />}
            >
              {remittance.remittanceType} Remittance Information
            </Button>
          )}
        </div>

        {(amtAccountingBalance && (amtAccountingBalance.amountDue>0 || amtAccountingBalance.prepay>0 || amtAccountingBalance.remainingCredit>0)) ? <AccountingBalance accountType="AMT" accountingBalance={amtAccountingBalance}/> : null }
        {(fsgAccountingBalance && (fsgAccountingBalance.amountDue>0 || fsgAccountingBalance.prepay>0 || fsgAccountingBalance.remainingCredit>0)) ? <AccountingBalance accountType="FSG" accountingBalance={fsgAccountingBalance}/> : null }
        {(amrsAccountingBalance && (amrsAccountingBalance.amountDue>0 || amrsAccountingBalance.prepay>0 || amrsAccountingBalance.remainingCredit>0)) ? <AccountingBalance accountType="AMRS" accountingBalance={amrsAccountingBalance}/> : null }
        {(agsgAccountingBalance && (agsgAccountingBalance.amountDue>0 || agsgAccountingBalance.prepay>0 || agsgAccountingBalance.remainingCredit>0)) ? <AccountingBalance accountType="AMRS" accountingBalance={agsgAccountingBalance}/> : null }
        
        <div className={`${TableStyle.tableWrapper}`}>
          <TableAllData
            columns={columns}
            data={fetchedData}
            isLoading={isLoading}
            download={canDownload ? { prefix: "Accounting", table: "Accounting" } : null}
            initialState={{ hiddenColumns: ['invoiceId'] }}
          />
        </div>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={TableStyle.invoicesDialog}
      >
        <DialogTitle id="alert-dialog-title">{"Invoice Payments"}</DialogTitle>
        <DialogContent>
          {checkingData ? (
            <LoaderAnimation />
          ) : dataEmpty ? (
            <h2>No Data</h2>
          ) : (
            <TableAllData
              tableType="invoices"
              columns={
                columnType === "paymentCol"
                  ? paymentColumns && paymentColumns
                  : columnType === "disbursementCol"
                  ? disbursementColumns && disbursementColumns
                  : columnType === "creditCol"
                  ? creditColumns && creditColumns
                  : ""
              }

              data={
                columnType === "paymentCol"
                  ? paymentData && paymentData
                  : columnType === "disbursementCol"
                  ? disbursementData && disbursementData
                  : columnType === "creditCol"
                  ? creditResponse && creditResponse
                  : ""
              }
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {selectedRemittance !== null ?
      <Dialog open={isRemittanceVisible}>
        <DialogTitle id="alert-dialog-title">{selectedRemittance.remittanceType} Remittance Information</DialogTitle>
        <DialogContent>
          <Box sx={{backgroundColor: "primary.main", color:"primary.contrastText"}} className={"modal-label"}>CHECK</Box>
          {selectedRemittance.address.map(line => 
            <div>{line}</div>
          )}

          <Box sx={{backgroundColor: "primary.main", color:"primary.contrastText", marginTop:"15px"}} className={"modal-label"}>WIRE/ACH INSTRUCTIONS</Box>
          <div>Bank: {selectedRemittance.bankName}</div>
          <div>Address: {selectedRemittance.bankAddress}</div>
          <div>Account Name: {selectedRemittance.accountName}</div>
          <div>Account Number: {selectedRemittance.accountNumber}</div>
          <div>Routing Number: {selectedRemittance.routingNumber}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRemittance} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog> : <></>}

      
      <Dialog
        open={doShowError}
        onClose={()=>setDoShowError(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"An Error Occurred"}</DialogTitle>
        <DialogContent>
          {errorText}
        </DialogContent>

        <DialogActions>
          <Button onClick={()=>setDoShowError(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Accounting;
